import { render } from "./Rapports.vue?vue&type=template&id=70ce4638"
import script from "./Rapports.vue?vue&type=script&lang=js"
export * from "./Rapports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__